import WarningIcon from '@material-ui/icons/Warning';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import { usePermission } from '@backstage/plugin-permission-react';
import {
  catalogUnprocessedEntitiesPermission,
  datadogAnalyticsPermission,
} from '../../permissions';
import { CustomSidebarItem } from './CustomSidebarItem';

/**
 * Sidebar item for Unprocessed Entities page - only visible to users with permission
 * Supports hide from sidebar and set as landing page functionality
 */
export const UnprocessedEntitiesSidebarItem = () => {
  const { loading, allowed = false } = usePermission({
    permission: catalogUnprocessedEntitiesPermission,
  });

  // Don't show anything while loading or if not allowed
  if (loading || !allowed) {
    return null;
  }

  return (
    <CustomSidebarItem
      icon={WarningIcon}
      to="/catalog-unprocessed-entities"
      text="Unprocessed Entities"
    />
  );
};

/**
 * Sidebar item for Datadog Analytics page.
 * Only visible to users granted the datadogAnalyticsPermission (for example, the
 * configured Backstage admin group).
 */
export const DatadogAnalyticsSidebarItem = () => {
  const { loading, allowed = false } = usePermission({
    permission: datadogAnalyticsPermission,
  });

  if (loading || !allowed) {
    return null;
  }

  return (
    <CustomSidebarItem
      icon={ShowChartIcon}
      to="/datadog-analytics"
      text="Analytics"
    />
  );
};
